import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { environment } from '../../../../environments/environment';

declare const google: any;

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [ReactiveFormsModule, RouterModule],
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  signupForm: FormGroup;
  loading = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.signupForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/)
      ]],
      firstName: ['', [Validators.required, Validators.minLength(1)]],
      lastName: ['', []],
      phone: ['', []]
    });
  }

  ngOnInit(): void {
    this.initializeGoogleSignIn();
  }

  private initializeGoogleSignIn(): void {
    if (typeof google !== 'undefined') {
      google.accounts.id.initialize({
        client_id: environment.googleClientId,
        callback: (response: any) => this.handleGoogleSignup(response)
      });

      google.accounts.id.renderButton(
        document.getElementById('googleSignUpButton'),
        {
          theme: 'outline',
          size: 'large',
          width: '100%',
          text: 'signup_with'
        }
      );
    } else {
      setTimeout(() => this.initializeGoogleSignIn(), 100);
    }
  }

  handleGoogleSignup(response: any): void {
    this.loading = true;
    this.errorMessage = '';

    this.authService.loginWithGoogle(response.credential).subscribe({
      next: (apiResponse) => {
        console.log('Google signup successful:', apiResponse);
        this.router.navigate(['/dashboard']);
      },
      error: (error) => {
        console.error('Google signup error:', error);
        this.errorMessage = error.error?.error?.message || 'Google signup failed. Please try again.';
        this.loading = false;
      }
    });
  }

  onSubmit(): void {
    if (this.signupForm.invalid) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    this.successMessage = '';

    const email = this.signupForm.value.email;

    this.authService.signup(this.signupForm.value).subscribe({
      next: (response) => {
        console.log('Signup successful:', response);
        this.loading = false;
        this.successMessage = `Account created successfully! We've sent a verification email to ${email}. Please check your inbox and click the verification link to activate your account.`;
        this.signupForm.reset();
      },
      error: (error) => {
        console.error('Signup error:', error);
        this.errorMessage = error.error?.error?.message || 'Signup failed. Please try again.';
        this.loading = false;
      }
    });
  }

  get email() {
    return this.signupForm.get('email');
  }

  get password() {
    return this.signupForm.get('password');
  }

  get firstName() {
    return this.signupForm.get('firstName');
  }

  get lastName() {
    return this.signupForm.get('lastName');
  }

  get phone() {
    return this.signupForm.get('phone');
  }
}
